import React, { useState, useContext, useCallback, useRef } from 'react'

import SearchContext from '../../components/context/SearchContext';

const Sort = ()=>{
    const {params, handleParams} = useContext(SearchContext);

    const sortOptions = {
        itemPublished_desc: 'Senast inkomna',
        noViews_desc: 'Mest populära',
        price_asc: 'Pris, lågt-högt',
        price_desc: 'Pris, högt-lågt',
        modelYear_desc: 'Årsmodell, nyare-äldre',
        modelYear_asc: 'Årsmodell, äldre-nyare'
    }

    const [active, setActive] = useState( (params.get('sort') || 'itemPublished_desc'))
    const select = useRef()

    const handleClick = useCallback((e)=>{

        if( active === select.current.value) { return }
        console.dir(select.current.value)

        setActive(select.current.value)
        const newParams = new URLSearchParams( params.toString());
        newParams.set('sort', select.current.value)
        handleParams(newParams)

    },[select, handleParams, setActive, active, params])

    return (
        <div className="sort">
            <select value={active} dir='rtl' ref={select} onChange={handleClick}>
                {Object.entries(sortOptions).map(([value, description]) => {
                    return (
                        <option key={value} value={value}>{description}</option>
                    )
                })}
            </select>
        </div>
    )

}

export default Sort


// const Sortbutton = ({active, order, sort, children, onClick}) => {

//     const [isActive, setIsActive] = useState((active.split('_')[0] === sort))
//     const [hasDefaultOrder, setHasDefaultOrder] = useState( isActive && (active.split('_')[1] === order))

//     const handleClick = useCallback((e)=>{
//         e.preventDefault()
//         let currentOrder = order
//         console.log({hasDefaultOrder,order, sort})
//         if( hasDefaultOrder && isActive ) {
//             currentOrder = order === 'desc' ? 'asc':'desc';
//         }
//         onClick(`${sort}_${currentOrder}`)
//     },[hasDefaultOrder, isActive, onClick, order, sort])

//     useEffect(()=>{
//         setIsActive((active.split('_')[0] === sort))
//         setHasDefaultOrder( (active.split('_')[1] === order))    
//     },[active, isActive, setIsActive, setHasDefaultOrder, order, sort])


//     return (
//         <a 
//             className={`${isActive ? 'active':''} ${order}`}
//             href={'#'+sort}
//             onClick={handleClick}
//         >
//             {children} 
//             {
//                 isActive && !hasDefaultOrder
//                     ? <span>&nbsp;&uarr;</span> 
//                     : <span>&nbsp;&darr;</span> 
//             }
//         </a>
//     )
// }
